import { render } from "./SolutionSection.vue?vue&type=template&id=233487e1"
import script from "./SolutionSection.vue?vue&type=script&lang=js"
export * from "./SolutionSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__